import qs from 'query-string';
import { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import LanguageContext from '../Language/LanguageContext';

export const useLocalizedHistoryPush = () => {
    const { language } = useContext(LanguageContext);
    const history = useHistory();

    return (url) => {
        const baseRoute = `/${language}`;
        const route = url && url !== '/' ? `${baseRoute}${url}` : baseRoute;
        history.push(route);
    };
};

export const getUrlWithoutLanguage = (language, url) => {
    // eslint-disable-next-line prefer-template
    const re = new RegExp(`^(/${language}/)`);

    return url.replace(re, '');
};

export const getUrlLanguage = (url) => {
    const prefix = url.match(/^(\/[a-z]{2}\/)|^\/[a-z]{2}$/g);
    if (prefix) {
        return prefix[0].substring(1, 3);
    }

    return undefined;
};

export const useUrlParams = () => {
    const location = useLocation();
    const history = useHistory();

    return (urlParams) => {
        const currentSearchParams = qs.parse(location.search);
        const newSearchParams = {
            ...currentSearchParams,
            ...urlParams,
        };
        Object.keys(newSearchParams).forEach((key) => {
            if ([null, undefined].includes(newSearchParams[key])) {
                delete newSearchParams[key];
            }
        });
        const search = `?${qs.stringify(newSearchParams)}`;
        history.push({ search });
    };
};

export const getUrlParams = () => {
    const { search } = useLocation();

    return qs.parse(search);
};
